import { User } from 'lucide-react'

import { formatAddress, formatCpf, formatPhone } from '../lib/format'
import type { MyDataPersonal } from '../types'

import { Card, CardBody, CardHeader, CardTitle } from '@/shared/ui/Card'

const NOT_INFORMED = 'Não informado'

function Field({
  label,
  value
}: {
  label: string
  value: string | number | null | undefined
}) {
  const display =
    value === null || value === undefined || value === '' ? NOT_INFORMED : String(value)
  const empty = display === NOT_INFORMED

  return (
    <div className="flex flex-col gap-0.5 py-2">
      <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
        {label}
      </span>
      <span
        className={empty ? 'text-sm italic text-muted-foreground' : 'text-sm font-semibold'}
      >
        {display}
      </span>
    </div>
  )
}

export function PersonalDataCard({ personal }: { personal: MyDataPersonal }) {
  return (
    <Card variant="default">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <span className="text-primary">
            <User className="size-5" aria-hidden />
          </span>
          Dados pessoais
        </CardTitle>
      </CardHeader>
      <CardBody className="divide-y divide-border">
        <Field label="Nome" value={personal.nome} />
        <Field label="E-mail" value={personal.email} />
        <Field label="CPF" value={formatCpf(personal.cpf)} />
        <Field label="Código do aluno" value={personal.codigo} />
        <Field label="Telefone" value={formatPhone(personal.telefone)} />
        <Field label="Endereço" value={formatAddress(personal.endereco)} />
        <Field label="Escola" value={personal.escola} />
        <Field label="Ano escolar" value={personal.ano_escolar} />
      </CardBody>
    </Card>
  )
}
